let tagHeight = 0;
$(function () {
    $(".rd_tag_list").each(function (key, item) {
        if ($(item).find(".rd_tag:first")) {
            if (
                !tagHeight ||
                tagHeight > $(item).find(".rd_tag:first")[0].clientHeight
            ) {
                tagHeight = $(item).find(".rd_tag:first")[0].clientHeight;
            }
        }
    });
    tagStatus();

    $(".rd_tag_more").on("click", function () {
        $(this).closest(".rd_tag_list").find(".rd_tag").show();
        $(this).text("... Less");
    });
});

function tagItemStatus(item) {
    if (
        $(item).find(".rd_tag:first") &&
        !$(item).hasClass("rd_tag_no_action") &&
        item.clientHeight > tagHeight * 2
    ) {
        $(item).find(".rd_tag:visible:last").hide();
        $(item).find(".rd_tag_more").show();
        tagItemStatus(item);
    } else {
        $(item).addClass("rd_tag_no_action");
    }
}

function tagStatus() {
    $(".rd_tag_list").each(function (key, item) {
        tagItemStatus(item);
    });
}
